import { handleActions } from 'redux-actions';

import { NOTIFICATIONS } from '../../types';

import { createReducer, baseReducer } from '../utils';

const initialState = {
  ...baseReducer,
  isOpened: false
};

const notifications = handleActions(
  {
    ...createReducer(NOTIFICATIONS, initialState),
    [`${NOTIFICATIONS}_isOpened`]: (state = initialState, { payload }) => ({
      ...state,
      isOpened: payload
    })
  },
  initialState
);

export default notifications;
